// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_2s98o","text":"index_text_1-SMB","textHidden":"index_textHidden_22C8_","contentBox":"index_contentBox_3DI84","boxTitle":"index_boxTitle_2gWUh"};